export const TITLE_MAP: Record<string, string> = {
  '/': 'Dashboard',
  '/clientes': 'Clientes',
  '/clientes/nuevo': 'Clientes',
  '/clientes/moral/nuevo': 'Clientes',
  '/clientes/fideicomiso/nuevo': 'Clientes',
  '/clientes/cotitular/nuevo': 'Clientes',
  '/clientes/carga-masiva': 'Clientes',
  '/fondos': 'Fondos',
  '/fondos/nuevo': 'Fondos',
  '/portafolio-modelo/portafolios': 'Portafolios',
  '/portafolio-modelo/estrategia': 'Estrategias',
  '/portafolio-modelo/rebalanceo': 'Rebalanceo',
  '/portafolio-modelo/restricciones': 'Restricciones',
  '/portafolio-modelo/ordenes-globales': 'Operaciones',
  '/portafolio-modelo/honorarios': 'Reportes',
  '/portafolio-modelo/inversion': 'Reportes',
  '/portafolio-modelo/reportes-operacion': 'Reportes',
  '/portafolio-modelo/documental': 'Reportes',
  '/portafolio-modelo/fondos': 'Reportes',
  '/portafolio-modelo/reporte-liquidez': 'Reportes',
  '/portafolio-modelo/perfiles': 'Perfiles',
  '/portafolio-fondos/portafolios': 'Portafolios de Fondos',
  '/portafolio-fondos/estrategia': 'Estrategias de Fondos',
  '/portafolio-fondos/restricciones': 'Restricciones de Fondos',
  '/portafolio-fondos/rebalanceo': 'Rebalanceo de Fondos',
  '/archivos/operacion': 'Operación',
  '/configuracion': 'Configuración',
  '/cumplimiento/operaciones': 'Cumplimiento',
  '/cumplimiento/restringidos': 'Cumplimiento',
  '/cumplimiento/servicios': 'Cumplimiento',
  '/cumplimiento/auditorias': 'Cumplimiento',
  '/cumplimiento/practicas-venta': 'Cumplimiento',
  '/cumplimiento/denuncias': 'Cumplimiento',
  '/cumplimiento/ebr': 'Cumplimiento',
  '/cumplimiento/riesgo': 'Cumplimiento',
  '/cumplimiento/operaciones-inusuales': 'Cumplimiento',
  '/cumplimiento/alertas': 'Cumplimiento',
  '/cumplimiento/reportes-operatividad': 'Cumplimiento',
  '/cumplimiento/montos-operados': 'Cumplimiento',
  '/cumplimiento/alertas-operativas': 'Cumplimiento',
} as const;

export const PATH_NAMES_CLEAN_REBALANCING_DATA = [
  '/portafolio-modelo/ordenes-globales',
  '/portafolio-modelo/rebalanceo',
  '/portafolio-modelo/portafolios',
  '/portafolio-modelo/estrategia',
  '/portafolio-modelo/restricciones',
  '/portafolio-fondos/ordenes-globales',
  '/portafolio-fondos/rebalanceo',
  '/portafolio-fondos/portafolios',
  '/portafolio-fondos/estrategia',
  '/portafolio-fondos/restricciones',
];

export const BACK_URL_PATHS = [
  '/clientes/fisica/',
  '/clientes/moral/',
  '/clientes/fideicomiso/',
  '/clientes/nuevo',
  '/clientes/moral/nuevo',
  '/clientes/fideicomiso/nuevo',
  '/clientes/cotitular/nuevo',
] as const;

export const POSITIONS_PATHS = [
  'posiciones-en-el-portafolio',
  'portafolio-ultimos-movimientos',
  'rendimientos',
];

export const ONBOARDING_PATHS = [
  '/clientes/fisica/',
  '/clientes/moral/',
  '/clientes/fideicomiso/',
];

export const NEW_CLIENT_PATHS = [
  '/clientes/nuevo',
  '/clientes/moral/nuevo',
  '/clientes/fideicomiso/nuevo',
];

export const DOCUMENTARY_PATHS = ['/portafolio-modelo/documental'];

export const COOWNERS_PATHS = ['/cotitular/'];

export const BACK_URLS = {
  ONBOARDING: '/clientes/onboarding',
  CLIENTS: '/clientes',
  FUNDS: '/fondos',
  REBALANCE: '/portafolio-modelo/rebalanceo',
  FUND_REBALANCE: '/portafolio-fondos/rebalanceo',
  NEW_CLIENT: '/clientes/nuevo',
} as const;
